import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  Typography,
  Box,
  Divider,
  Paper,
  Button,
  TextField,
  FormLabel,
  FormControl,
  IconButton,
  Checkbox,
  Tooltip,
  LinearProgress,
  MenuItem,
  InputLabel,
  Select,
  Chip,
  Breadcrumbs,
  useTheme,
  FormHelperText
} from "@mui/material";
import { tokens } from "../../../Theme";
import {
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridToolbarContainer,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  BankFetchData,
  BankpostData,
  BiometricpostData,
  companyTermsGet,
  CompReportFetchData,
  CompReportpostData,
  getBiometricData,
  getFetchData,
  PolicyFetchData,
  PolicyUpdateData,
  postData,
} from "../../../store/reducers/Formapireducer";
import { toast } from "react-hot-toast";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { LoadingButton } from "@mui/lab";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/utils";
import {
  CheckinAutocomplete,
  MultiFormikOptimizedAutocomplete,
  SingleFormikOptimizedAutocomplete,

  STDCheckinAutocomplete,

  STDMultiFormikOptimizedAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import store from "../../..";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  CompanyimageUpload,
  imageUpload,
} from "../../../store/reducers/Imguploadreducer";
import Resizer from "react-image-file-resizer";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { Image } from "@mui/icons-material";
import { TbBoxMultiple1 } from "react-icons/tb";
import { nanoid } from "@reduxjs/toolkit";
import { slotListView } from "../../../store/reducers/Explorelitviewapireducer";

export const companySchema = Yup.object().shape({
  address: Yup.string().max(500, "Address must be 500 character "),
  phone: Yup.string().max(10, "Not Valid Phone Number"),
  pincode: Yup.number()
    .min(10000, "Not valid Pin Code")
    .max(999999, "Not valid Pin Code"),
  country: Yup.object().required("Please select a country").nullable(),
  license: Yup.string()
    .matches(
      /^[a-zA-Z0-9]{4}$/,
      "Please enter alphabets only, exactly 4 characters",
    ) // Only letters and digits, 4 characters long
    .test(
      "contains-both",
      "The code must contain both letters and numbers",
      (value) => {
        return /[a-zA-Z]/.test(value) && /\d/.test(value); // Must contain both letters and numbers
      },
    ),
  iECode: Yup.string()
    .matches(/^[-_ a-zA-Z0-9]+$/, "Please enter alphabets only")
    .min(10, "I.E.Code must be 10 character"),
  gst: Yup.string()
    .matches(/^[-_ a-zA-Z0-9]+$/, "Only Numeric and Alphabets ")
    .min(15, "GST must be 15 character"),
  email: Yup.string().email("Please enter a valid Email"),
  name: Yup.string()
    .max(50)
    .matches(/^[A-Za-z\s\.'-]+$/, "Please enter alphabets only"),
});

const Editcompany = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const YearFlag = sessionStorage.getItem("YearFlag");
  console.log(YearFlag, "--YearFlag in EditCompany");

  const Year = sessionStorage.getItem("year");
  const Finyear = sessionStorage.getItem("YearRecorid");
  const CompanyID = sessionStorage.getItem("compID");

  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const [BankValidationSchema, setBankValidationSchema] = useState(null);
  const [show, setScreen] = React.useState("0");
  const [headerImage, setheaderImage] = useState("");
  const [footerImage, setfooterImage] = useState("");
  const [esignImage, setesignImage] = useState("");
  const [qrCodeImage, setqrCodeImage] = useState("");

  const lookuplistViewurl = useSelector((state) => state.globalurl.listViewurl);


  //IMAGE PREVIEW
  const [headerPreview, setHeaderPreview] = useState(""); // blob preview url
  const [footerPreview, setFooterPreview] = useState(""); // blob preview url
  const [eSignPreview, seteSignPreview] = useState(""); // blob preview url
  const [qrCodePreview, setqrCodePreview] = useState(""); // blob preview url

  const data = useSelector((state) => state.formApi.Data);

  let recID = params.id;
  console.log(recID, "--recID");

  let mode = params.Mode;
  let accessID = params.accessID;
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        // const schema = Yup.object().shape({
        //   address: Yup.string().required(data.Company.address),
        //   name: Yup.string().required(data.Company.name),
        //   country: Yup.object().required(data.Company.country).nullable(),
        //   email: Yup.string().required(data.Company.email),
        //   pincode: Yup.string().required(data.Company.pincode),
        //   license: Yup.string().required(data.Company.license),

        //   gst: Yup.string().required(data.Company.gst),
        //   phone: Yup.string().required(data.Company.phone),
        // });
        let schemaFields1 = {
          address: Yup.string().required(data.Company.address),
          name: Yup.string().required(data.Company.name),
          country: Yup.object().required(data.Company.country).nullable(),
          email: Yup.string()
            .required(data.Company.email)
            .matches(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              "Invalid Email format",
            ),

          pincode: Yup.string()
            .required(data.Company.pincode)
            .matches(/^\d{6}$/, "Invalid Pincode"),
          license: Yup.string().required(data.Company.license),


          phone: Yup.string()
            .required(data.Company.phone)
            .matches(/^[6-9]\d{9}$/, "Invalid Phone Number"),
          // Type: Yup.string().required(data.Company.Type),
          //           Type: Yup.string().when([], {
          //   is: () => mode !== "E",
          //   then: (schema) => schema.required(data.Company.Type),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          Type:
            mode !== "E"
              ? Yup.string().required(data.Company.Type)
              : Yup.string().notRequired(),
        };
        schemaFields1.gst = Yup.string()
          .nullable()
          .notRequired()
          .transform((value) => (value === "" ? null : value))
          .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            "Invalid GST number",
          );
        // IE Code
        schemaFields1.iECode = Yup.string()
          .nullable()
          .notRequired()
          .transform((value) => (value === "" ? null : value))
          .matches(/^[A-Za-z0-9]{10}$/, data.Company.iECode);

        // RBI Code
        schemaFields1.rbiCode = Yup.string()
          .nullable()
          .notRequired()
          .transform((value) => (value === "" ? null : value))
          .matches(/^[A-Za-z0-9]{7,11}$/, data.Company.rbiCode);

        // ************** 2. BANK SCHEMA **************
        const BankSchema = Yup.object().shape({
          bankname: Yup.string().required(data.BankDetails.bankname),
          branchname: Yup.string().required(data.BankDetails.branchname),
          Accounttype: Yup.string().required(data.BankDetails.Accounttype),

          ifsc: Yup.string()
            .required(data.BankDetails.ifsc)
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code"),

          accountnumber: Yup.string()
            .required(data.BankDetails.accountnumber)
            .matches(/^\d{9,18}$/, "Invalid Account Number"),

          bankloc: Yup.string().required(data.BankDetails.bankloc),
          accountholdname: Yup.string().required(
            data.BankDetails.accountholdname,
          ),
          bankaddress: Yup.string().required(data.BankDetails.bankaddress),
        });

        // ************** 3. SET STATE **************
        const schema1 = Yup.object().shape(schemaFields1);

        setBankValidationSchema(BankSchema);
        setValidationSchema(schema1);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
  }, [location.key]);

  const [validationSchema2, setValidationSchema2] = useState(null);

  const { toggleSidebar, broken, rtl } = useProSidebar();
  const Data = useSelector((state) => state.formApi.Data);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const isLoading = useSelector((state) => state.formApi.postLoading);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = useState(15);
  const exploreLoading = useSelector((state) => state.exploreApi.loading);

  const partyBankgetdata = useSelector((state) => state.formApi.BankData);
  const CompReportgetdata = useSelector(
    (state) => state.formApi.CompReportData,
  );
  const BankgetLoading = useSelector((state) => state.formApi.BankgetLoading);
  const CompReportgetLoading = useSelector(
    (state) => state.formApi.CompReportgetLoading,
  );
  const BankisLoading = useSelector((state) => state.formApi.BankpostLoading);
  const CompReportpostDataLoading = useSelector(
    (state) => state.formApi.CompReportpostDataLoading,
  );
  const [loading, setLoading] = useState(false);

  //POLICY_GET
  const PolicyData = useSelector((state) => state.formApi.PolicyData);
  const PolicygetLoading = useSelector(
    (state) => state.formApi.PolicygetLoading,
  );

  //TERMS_GET
  const companytermsData = useSelector((state) => state.formApi.companytermsData);
  console.log(companytermsData, "--companytermsData");


  const rowData = location.state || {};

  const slotRowData = useSelector((state) => state.exploreApi.slotRowData);
  console.log(slotRowData, "--slotRowData");

  const [rows, setRows] = React.useState(slotRowData);
  const [rowModesModel, setRowModesModel] = React.useState({});

  // const [termsrows, setTermsRows] = React.useState(companytermsData);
  const [termsrows, setTermsRows] = useState({});
  const [termsRowModesModel, setTermsRowModesModel] = useState({});


  useEffect(() => {
    setRows(slotRowData || []);
  }, [slotRowData]);

  useEffect(() => {
    setTermsRows(companytermsData || []);
  }, [companytermsData]);

  //   useEffect(() => {
  //     console.log(show, "--show");

  //   if (show === "4") {
  //     setRows(slotRowData || []);
  //   } else if (show === "5") {
  //     setTermsRows(companytermsData || []);
  //   }
  // }, [show, slotRowData, companytermsData]);

  const screenChange = async (event) => {
    setScreen(event.target.value);
    if (event.target.value == "0") {
      console.log(event.target.value, "--find event.target.value");

      if (recID && mode === "E") {
        dispatch(getFetchData({ accessID, get: "get", recID }));
      } else {
        dispatch(getFetchData({ accessID, get: "", recID }));
      }
    }
    if (event.target.value == "1") {
      if (recID && mode === "E") {
        dispatch(BankFetchData({ get: "get", recID }));
      } else {
        dispatch(BankFetchData({ get: "", recID }));
      }
    }
    if (event.target.value == "2") {
      if (recID && mode === "E") {
        dispatch(CompReportFetchData({ recID }));
      } else {
        dispatch(CompReportFetchData({ get: "", recID }));
      }
    }
    //Policy
    if (event.target.value == "3") {
      if (recID && mode === "E") {
        dispatch(PolicyFetchData({ get: "get", recID }));
      } else {
        dispatch(PolicyFetchData({ get: "", recID }));
      }
    }
    if (event.target.value == "4") {
      if (recID && mode === "E") {
        dispatch(getBiometricData({
          CompanyID : recID
        }));
      }
    }

    //Slot Screen
    // if (event.target.value == "4") {
    //   if (recID && mode === "E") {
    //     dispatch(PolicyFetchData({ get: "get", recID }));
    //     const data = await dispatch(
    //       slotListView({
    //         accessID: "TR334",
    //         screenName: "Slot",
    //         filter: `CompanyID = ${recID}`,
    //         any: "",
    //       }),
    //     );
    //     console.log(rows, "--finding rows inside ScreenChange");

    //     // setRows(slotRowData);
    //     console.log("🚀 ~ screenChange ~ data:", data);
    //   } else {
    //     dispatch(PolicyFetchData({ get: "", recID }));
    //   }
    // }
    // if (event.target.value == "4") {
    //   if (recID && mode === "E") {
    //     dispatch(PolicyFetchData({ get: "get", recID }));

    //     const data = await dispatch(
    //       slotListView({
    //         accessID: "TR334",
    //         screenName: "Slot",
    //         filter: `CompanyID = ${recID}`,
    //         any: "",
    //       })
    //     );

    //     if (data.payload.Status === "Y") {
    //       const resData = data.payload.Data.rows.map((value) => {
    //         return {
    //           ...value,
    //           Break: value.Break === "Y", // ✅ convert Y/N → true/false
    //           isNew: false,
    //         };
    //       });

    //       setRows(resData);
    //     } else {
    //       setRows([]);
    //     }
    //   } else {
    //     dispatch(PolicyFetchData({ get: "", recID }));
    //   }
    // }
    if (event.target.value == "5") {
      if (recID && mode === "E") {
        dispatch(PolicyFetchData({ get: "get", recID }));
        dispatch(companyTermsGet({ recID }));
        // const data = await dispatch(
        //   slotListView({
        //     accessID: "TR355",
        //     screenName: "Terms",
        //     filter: `CompanyID = ${recID}`,
        //     any: "",
        //   }),
        // );
        // console.log(rows, "--finding rows inside ScreenChange");

        // setRows(slotRowData);
        console.log("🚀 ~ screenChange ~ data:", data);
      } else {
        dispatch(PolicyFetchData({ get: "get", recID }));
        dispatch(companyTermsGet({ recID }));
      }
    }
  };



  const initialValues = {
    code: Data.Code,
    recordID: Data.RecordID,
    name: Data.Name,
    address: Data.Address,
    pincode: Data.Pincode,
    phone: Data.Phone,
    fax: Data.Fax,
    email: Data.Email,
    web: Data.Web,
    cst: Data.Cst,
    areacode: Data.Areacode,
    iECode: Data.Iecode,
    rbiCode: Data.Rbicode,
    gst: Data.Gst,
    Lut: Data.Lut,
    sortOrder: Data.SortOrder,
    license: Data.License,
    subattapplicable: Data.SubjectAttendanceApplicable === "Y" ? true : false,
    disable: Data.Disable === "Y" ? true : false,
    stockClose: Data.Process === "Y" ? true : false,
    useregular: Data.Regularslno === "Y" ? true : false,
    noOfEmployees: Data.NumberOfEmployee,
    noofusers: Data.NumberOfUsers,
    country: Data.CnRecordID
      ? {
        RecordID: Data.CnRecordID,
        Code: Data.CountryCode,
        Name: Data.CountryName,
      }
      : null,
    Stock5sDataSource: Data.Stock5sDataSource || "",
    Module: mode === "E" ? Data.Module : "",
    Type: Data.Type || "",
    // == "S" ? "Startup" : Data.Type == "I" ? "Institute" : Data.Type == "C" ? "Construction" : "",
    noticeperiod: Data.NoticePeriod
  };

  /*************************SAVE FUCTION*********************/
  const fnSave = async (values) => {
    var idata = {
      RecordID: recID,
      CnRecordID: values.country.RecordID || 0,
      CountryCode: values.country.Code || "",
      CountryName: values.country.Name || "",
      Code: values.code,
      Name: values.name,
      Email: values.email,
      Address: values.address,
      Pincode: values.pincode,
      Phone: values.phone,
      Fax: values.fax,
      Web: values.web,
      Cst: values.cst,
      Areacode: values.areacode,
      Iecode: values.iECode,
      Rbicode: values.rbiCode,
      Gst: values.gst,
      Lut: values.Lut,
      SortOrder: values.sortOrder || 0,
      License: values.license,
      SubjectAttendanceApplicable: values.subattapplicable === true ? "Y" : "N",
      Disable: values.disable === true ? "Y" : "N",
      Process: values.stockClose === true ? "Y" : "N",
      Regularslno: values.useregular === true ? "Y" : "N",
      NumberOfEmployee: values.noOfEmployees,
      NumberOfUsers: values.noofusers,
      Module: values.Module,
      Stock5sDataSource: values.Stock5sDataSource || "",
      // Type: values.Type,
      Type: values.Type,
      // == "Startup" ? "S" : values.Type == "Institute" ? "I" : values.Type == "Construction" ? "C" : "",
      NoticePeriod: values.noticeperiod
    };
    console.log(values.Module);

    let action = mode === "A" ? "insert" : "update";
    const data = await dispatch(postData({ accessID, action, idata }));
    if (data.payload.Status == "Y") {
      toast.success(data.payload.Msg);
      // if (mode === "A") {
      //   navigate(-1);
      // } else if (mode === "E") {
      //   setScreen("0");
      // }
      navigate(`/Apps/TR014/Company`);
    } else {
      toast.error(data.payload.Msg);
    }
  };

  const BankInitialValue = {
    code: partyBankgetdata.Code || "",
    name: partyBankgetdata.Name || "",
    bankname: partyBankgetdata.BankName || "",
    Accounttype: partyBankgetdata.BankAccountType || "",
    branchname: partyBankgetdata.BankBranchName || "",
    ifsc: partyBankgetdata.BankIfsc || "",
    bankloc: partyBankgetdata.BankLocation || "",
    accountnumber: partyBankgetdata.BankAccountNo || "",
    bankaddress: partyBankgetdata.BankAddress || "",
    accountholdname: partyBankgetdata.BankAccountHolderName || "",
  };

  const Banksave = async (values, del) => {
    setLoading(true);

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";

    const idata = {
      action: "update",
      RecordID: recID,
      BankName: values.bankname,
      BankBranchName: values.branchname,
      BankAccountHolderName: values.accountholdname,
      BankAccountNo: values.accountnumber,
      BankAccountType: values.Accounttype,
      BankIfsc: values.ifsc,
      BankLocation: values.bankloc,
      BankAddress: values.bankaddress,
    };

    try {
      const response = await dispatch(BankpostData({ idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
        setScreen("1");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };
  const BiometricInitialValue = {
    code: data.Code || "",
    name: data.Name || "",
    appname: data.ApplicationName,
    deviceid: data.DevicesID,
    authorization: data.Authorization,
    apikey: data.ApiKey,
    url: data.Url,
    input: data.Input,
    time: data.DailyTime,
    pulling: data.PullingCycle || "",
  };
    console.log(BiometricInitialValue,data,"BiometricInitialValue");

  const Biometricsave = async (values) => {

    const idata = {
      action: "update",
      CompanyID: recID,
      ApplicationName: values.appname,
      DevicesID: values.deviceid,
      Authorization: values.authorization,
      ApiKey: values.apikey,
      Url: values.url,
      Input: values.input,
      DailyTime: values.time,
      PullingCycle: values.pulling

    };

    const response = await dispatch(BiometricpostData({ idata }));
    if (response.payload.Status === "Y") {
      const dbResult = JSON.parse(response.payload.DbResult);

      toast.success(dbResult.Msg);
      dispatch(getBiometricData({
        CompanyID : recID
      }));
      // navigate("/Apps/bioconfiguration");
    } else {
      const dbResult = response.payload.DbResult
        ? JSON.parse(response.payload.DbResult)
        : null;

      toast.error(dbResult?.Msg || response.payload.Msg || "Something went wrong");
    }

  };
  // POLICY SCREEN
  const PolicyInitialValue = {
    code: PolicyData.Code || "",
    name: PolicyData.Name || "",
    noofpermhrs: PolicyData.PerNumberOfHours || 0,
    noofpaidleave: PolicyData.NoOfPaidLeavePerYear || 0,
    noofpermpermonth: PolicyData.PerNumberOfMonth || 0,
    lossofpayrate: PolicyData.PerLossOfPayRate || 0,
    freeormonth: PolicyData.IrFreeMonth || 0,
    lossofpayrate2: PolicyData.IrLossOfPayRate || 0,
    salryrateorday: PolicyData.OtSalaryRatePerDay || 0,
  };

  const Policysave = async (values, del) => {
    setLoading(true);

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";

    const idata = {
      action: "update",
      RecordID: recID,
      PerNumberOfHours: values.noofpermhrs,
      PerNumberOfMonth: values.noofpermpermonth,
      NoOfPaidLeavePerYear: values.noofpaidleave,
      PerLossOfPayRate: values.lossofpayrate,
      IrFreeMonth: values.freeormonth,
      IrLossOfPayRate: values.lossofpayrate2,
      OtSalaryRatePerDay: values.salryrateorday,
    };

    try {
      const response = await dispatch(PolicyUpdateData({ idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
        setScreen("3");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };

  const CompReportInitialValue = {
    code: CompReportgetdata.Code || "",
    name: CompReportgetdata.Name || "",
    CmHeader: CompReportgetdata.CmHeader || "",
    CmFooter: CompReportgetdata.CmFooter || "",
    Signature: CompReportgetdata.Signature || "",
    QrCode: CompReportgetdata.QrCode || "",
  };

  const CompReportsave = async (values, del) => {
    setLoading(true);

    const idata = {
      action: "update",
      CompanyID: recID,
      QrCode:
        qrCodeImage && qrCodeImage !== ""
          ? qrCodeImage
          : CompReportgetdata.QrCode,

      Signature:
        esignImage && esignImage !== ""
          ? esignImage
          : CompReportgetdata.Signature,

      CmHeader:
        headerImage && headerImage !== ""
          ? headerImage
          : CompReportgetdata.CmHeader,

      CmFooter:
        footerImage && footerImage !== ""
          ? footerImage
          : CompReportgetdata.CmFooter,
    };

    try {
      const response = await dispatch(CompReportpostData({ idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
        setScreen("2");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR014/Company");
        }
      } else {
        return;
      }
    });
  };


  const validateImageFile = (file) => {
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!file) return { valid: false, message: "No file selected" };

    if (!allowedTypes.includes(file.type)) {
      return { valid: false, message: "Only PNG, JPEG and JPG images are allowed" };
    }

    if (file.size > maxSize) {
      return { valid: false, message: "File size must be less than 2MB" };
    }

    return { valid: true };
  };

  const getFileHeaderChange1 = async (event) => {
    const file = event.target.files[0];
    const validation = validateImageFile(file);
    if (!validation.valid) {
      toast.error(validation.message);
      event.target.value = "";
      return;
    }
    setheaderImage(event.target.files[0]);
    setHeaderPreview(URL.createObjectURL(event.target.files[0]));

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "images");

    const fileData = await dispatch(CompanyimageUpload({ formData }));
    setheaderImage(fileData.payload.name);
    console.log(">>>", fileData.payload);
    console.log(
      "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
      fileData,
    );
    if (fileData.payload.Status == "Y") {
      // console.log("I am here");
      toast.success(fileData.payload.Msg);
    }
  };

  const getFileFooterChange = async (event) => {
    const file = event.target.files[0];
    const validation = validateImageFile(file);
    if (!validation.valid) {
      toast.error(validation.message);
      event.target.value = "";
      return;
    }

    setfooterImage(event.target.files[0]);
    setFooterPreview(URL.createObjectURL(event.target.files[0]));
    console.log(event.target.files[0]);
    //setFooterPreview(URL.createObjectURL(event.target.files[0]));

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "images");

    const fileData = await dispatch(CompanyimageUpload({ formData }));
    setfooterImage(fileData.payload.name);
    console.log(">>>", fileData.payload);
    console.log(
      "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
      fileData,
    );
    if (fileData.payload.Status == "Y") {
      // console.log("I am here");
      toast.success(fileData.payload.Msg);
    }
  };

  const getFileESignChange = async (event) => {
    const file = event.target.files[0];
    const validation = validateImageFile(file);
    if (!validation.valid) {
      toast.error(validation.message);
      event.target.value = "";
      return;
    }

    setesignImage(event.target.files[0]);

    seteSignPreview(URL.createObjectURL(event.target.files[0]));
    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "images");

    const fileData = await dispatch(CompanyimageUpload({ formData }));
    setesignImage(fileData.payload.name);
    console.log(">>>", fileData.payload);
    console.log(
      "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
      fileData,
    );
    if (fileData.payload.Status == "Y") {
      // console.log("I am here");
      toast.success(fileData.payload.Msg);
    }
  };

  const getFileQRCodeChange = async (event) => {
    const file = event.target.files[0];
    const validation = validateImageFile(file);
    if (!validation.valid) {
      toast.error(validation.message);
      event.target.value = "";
      return;
    }

    setqrCodeImage(event.target.files[0]);

    console.log(event.target.files[0]);
    setqrCodePreview(URL.createObjectURL(event.target.files[0]));
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "images");

    const fileData = await dispatch(CompanyimageUpload({ formData }));
    setqrCodeImage(fileData.payload.name);
    console.log(">>>", fileData.payload);
    console.log(
      "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
      fileData,
    );
    if (fileData.payload.Status == "Y") {
      // console.log("I am here");
      toast.success(fileData.payload.Msg);
    }
  };

  //SLOT Screen_COMPANYEXPLORE

  const columns = [
    {
      field: "SLNO",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      headerName: "RecordID",
      field: "RecordID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
    },

    // {
    //   field: "SlotCode",
    //   headerName: "Slot Code",
    //   width: 150,
    //   align: "left",
    //   headerAlign: "center",
    //   editable: false,
    // },
    {
      headerName: "Slot Code",
      field: "SlotCode",
      width: 150,
      hide: false,
      editable: true,
      headerAlign: "center",
      renderCell: (params) => {
        // show "Auto Code" only for new rows OR empty code
        if (!params.value || params.row.isNew) {
          return "Auto Code";
        }

        return params.value;
      }
    },
    {
      field: "SlotName",
      headerName: (
        <span>
          Slot Name <span style={{ color: "red" }}>*</span>
        </span>
      ),
      // headerName: "Slot Name",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
    },
    {
      // headerName: "From Time",
      headerName: (
        <span>
          From Time <span style={{ color: "red" }}>*</span>
        </span>
      ),
      field: "FromTime", // ✅ match exact API field
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
      renderCell: (params) => formatTo12Hour(params.value),
      renderEditCell: (params) => <EditTimeCell {...params} />,
    },
    {
      // headerName: "To Time",
      headerName: (
        <span>
          To Time <span style={{ color: "red" }}>*</span>
        </span>
      ),
      field: "ToTime", // ✅ match exact API field
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
      renderCell: (params) => formatTo12Hour(params.value),
      renderEditCell: (params) => <EditTimeCell {...params} />,
    },
    {
      field: "Comments",
      headerName: "Comments",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
      type: "text",
    },
    {
      field: "Break",
      headerName: "Break",
      width: 120,
      align: "center",
      headerAlign: "center",
      editable: true,

      // Display checkbox in normal mode
      renderCell: (params) => (
        <Checkbox
          // checked={Boolean(params.row.Break)}
          checked={params.row.Break}
          disabled
        />
      ),

      // Checkbox when row is in edit mode
      renderEditCell: (params) => {
        const { id, field, value, api } = params;

        const handleChange = (event) => {
          const checked = event.target.checked;

          api.setEditCellValue({
            id,
            field,
            value: checked,
          });

          api.stopCellEditMode({ id, field }); // refresh row
        };

        return (
          <Checkbox
            checked={Boolean(value)}
            onChange={handleChange}
            color="primary"
          />
        );
      },
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              material={{
                sx: {
                  color: "primary.main",
                },
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          // <GridActionsCellItem
          //   icon={<AddIcon style={{ color: "#00563B" }} />}
          //   label="Add"
          //   // onClick={() => handleInsertInrow(id)}
          //   color="inherit"
          // />,
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.Edit },
    });
  };

  const handleSaveClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.View },
    });
  };

  const handleDeleteClick = (RecordID) => async () => {
    setRows(rows.filter((row) => row.RecordID !== RecordID));

    if (!isNaN(RecordID)) {
      const idata = {
        //RecordID: recID,
        RecordID: RecordID,
      };

      const response = await dispatch(
        postData({
          accessID: "TR334",
          action: "harddelete",
          idata: idata,
        }),
      );

      if (response.payload?.Status === "Y") {
        toast.success(response.payload.Msg);
        const data = await dispatch(
          slotListView({
            accessID: "TR334",
            screenName: "Slot",
            filter: `CompanyID = ${recID}`,
            any: "",
          }),
        );
        console.log("🚀 ~ screenChange ~ data:", data);


        if (data.payload.Status === "Y") {
          const resData = data.payload.Data.rows.map((value) => ({
            ...value,
            Break: value.Break === "Y", // ✅ Convert Y/N → boolean
            isNew: false, // ✅ Mark all fetched rows as existing (not new)
          }));

          setRows(resData);
        } else {
          setRows([]);
        }
      } else {
        toast.error(response.payload?.Msg || "Operation failed");
      }
    }
  };

  const handleCancelClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.RecordID === RecordID);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.RecordID !== RecordID));
    }
  };
  const validateRowSlot = (row) => {
    if (!row.SlotName) {
      return "Please Enter the Slot Name";
    }
    if (!row.FromTime) {
      return "Please Select the From Time";
    }
    if (!row.ToTime) {
      return "Please Select the To Time";
    }

    // ✅ Time validation
    const from = new Date(`1970-01-01T${row.FromTime}`);
    const to = new Date(`1970-01-01T${row.ToTime}`);

    if (to <= from) {
      return "To Time must be greater than From Time";
    }

    return null;
  };

  const processRowUpdate = (newRow, oldRow) => {
    console.log(newRow, "--procesrowupdateterms newrow");
    //validation
    const error = validateRowSlot(newRow);
    if (error) {
      throw new Error(error);
    }



    const updatedRow = { ...newRow, isNew: false };
    console.log(newRow, "newRow");
    console.log(oldRow, "--oldRow");

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.RecordID === newRow.RecordID ? updatedRow : row,
      ),
    );

    console.log(updatedRow, "--updatedRow");

    return updatedRow;
  };



  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  function EditTimeCell(props) {
    const { id, field, value, api } = props;

    const handleChange = (event) => {
      const newValue = event.target.value;
      api.setEditCellValue({ id, field, value: newValue });
    };

    // Remove seconds if present (09:00:00 → 09:00)
    const formattedValue = value ? value.slice(0, 5) : "";

    return (
      <TextField
        type="time"
        fullWidth
        size="small"
        value={formattedValue}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    );
  }

  function EditTimeCell(props) {
    const { id, field, value, api } = props;

    const convertTo24Hour = (time12h) => {
      if (!time12h) return "";

      const [time, modifier] = time12h.split(" ");
      let [hours, minutes] = time.split(":");

      if (modifier === "PM" && hours !== "12") {
        hours = String(parseInt(hours, 10) + 12);
      }
      if (modifier === "AM" && hours === "12") {
        hours = "00";
      }

      return `${hours.padStart(2, "0")}:${minutes}`;
    };

    const convertTo12Hour = (time24) => {
      if (!time24) return "";

      const [hour, minute] = time24.split(":");
      let h = parseInt(hour);
      const ampm = h >= 12 ? "PM" : "AM";

      h = h % 12 || 12;

      return `${h}:${minute} ${ampm}`;
    };

    const handleChange = (event) => {
      const val24 = event.target.value; // 16:30
      const val12 = convertTo12Hour(val24); // 4:30 PM

      api.setEditCellValue({ id, field, value: val12 });
    };

    return (
      <TextField
        type="time"
        fullWidth
        size="small"
        value={convertTo24Hour(value)} // show correct time in picker
        onChange={handleChange}
      />
    );
  }


  const formatTo12Hour = (time) => {
    if (!time) return "";

    // ✅ If already formatted (contains AM/PM), return as is
    if (
      time.toUpperCase().includes("AM") ||
      time.toUpperCase().includes("PM")
    ) {
      return time;
    }

    const [hour, minute] = time.split(":");
    let h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12;
    h = h ? h : 12;

    return `${h}:${minute} ${ampm}`;
  };

  const handleSaveButtonClick = async (action) => {

    for (let index = 0; index < rows.length; index++) {
      const row = rows[index];
      const error = validateRowSlot(row);

      if (error) {
        toast.error(`${error}`);
        return; // ✅ stops entire save function
      }
    }

    const idata = rows.map((row, index) => {
      console.log(row, "--row in a save");
      console.log(parseInt(row.RecordID, 10), "--row in a save strung");

      const parsedID = parseInt(row.RecordID, 10);


      return {
        RecordID: !isNaN(parsedID) ? parsedID : -1,
        // RecordID: row.isNew ? 0 : row.RecordID,
        // RecordID: !isNaN(parseInt(row.RecordID, 10)) ? row.RecordID: -1,
        CompanyID: recID,
        Code: row.SlotCode,
        SlotName: row.SlotName,
        Comments: row.Comments,
        FromTime: formatTo12Hour(row.FromTime),
        ToTime: formatTo12Hour(row.ToTime),
        Break: row.Break ? "Y" : "N",
        SortOrder: 0,
        IsEditable: !isNaN(parsedID) ? "Y" : "N",
        // IsEditable: !isNaN(parseInt(row.RecordID, 10)) ? "Y" : "N"
      };
    });
    console.log(idata, "--print the idata");

    // return;
    try {
      const response = await dispatch(
        postData({
          accessID: "TR334",
          action: "insert",
          idata: idata,
        }),
      );

      // Check response status for success
      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        const data = await dispatch(
          slotListView({
            accessID: "TR334",
            screenName: "Slot",
            filter: `CompanyID = ${recID}`,
            any: "",
          }),
        );
        console.log("🚀 ~ screenChange ~ data:", data);
        if (data.payload.Status == "Y") {
          const resData = data.payload.Data.rows.map((value) => {
            return {
              ...value,
              Break: value.Break === "Y",  // convert to boolean
              isNew: false, // mark all rows as existing after save

            };
          });
          setRows(resData);

        } else {
          setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
        }
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      console.error("Save error:", error);
      toast.error("Error occurred during save.");
    }
  };

  function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;

    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          SlotCode: "",
          SlotName: "",
          FromTime: "",
          ToTime: "",
          Comments: "",
          Break: false,
          isNew: true,

        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "SlotCode" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          marginBottom: "10px",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
          Add Record
        </Button>
      </GridToolbarContainer>
    );
  }


  //==============================TERMS SECTION ================================================//  
  function EditfromDateCell(props) {
    const { id, field, value, api } = props;

    const formatToInputDate = (val) => {
      if (!val) return "";

      const date = new Date(val);
      if (isNaN(date.getTime())) return "";   // prevent invalid time error

      return date.toISOString().split("T")[0];
    };

    const handleChange = (event) => {
      const newValue = event.target.value;
      api.setEditCellValue({ id, field, value: newValue });
    };

    return (
      <TextField
        type="date"
        fullWidth
        size="small"
        value={formatToInputDate(value)}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    );
  }

  //STANDARD_LOOKUP
  // function STDEditAutocompleteCell(props) {
  //   console.log(props,"props")
  // // const { id, value, field, api, row } = props;

  // // const handleChange = async (event, newValue) => {
  // //   if (!newValue) return;

  // //   await api.setEditCellValue({
  // //     id,
  // //     field,
  // //     value: newValue,
  // //   });

  // //   api.stopCellEditMode({ id, field });
  // // };
  //   const { id, value, field, api, row } = props;

  //   const handleChange = async (newValue) => {
  //     console.log("🚀 ~ handleChange ~ newValue:", newValue);
  //     if (!newValue) return;

  //     setStdName(newValue);
  //     await api.setEditCellValue({
  //       id,
  //       field: "StandardName",
  //       value: newValue,
  //     });

  //     api.stopCellEditMode({ id, field });
  //   };
  //   const [stdname, setStdName] = useState(row.StandardName ? row.StandardName : null);

  // return (
  //   <STDCheckinAutocomplete
  //     name="Standard"
  //     // label="Standard"
  //     id="Standard"
  //     value={stdname || null}
  //     onChange={handleChange}
  //     url={`${lookuplistViewurl}?data={"Query":{"AccessID":"2157","ScreenName":"Standard","Filter":"parentID='${recID}'","Any":""}}`}
  //   />
  // );
  // }
  function STDEditAutocompleteCell(props) {
    console.log(props, "");
    const { id, value, field, api, row } = props;

    const handleChange = async (event, newValue) => {
      if (!newValue) return;

      await api.setEditCellValue({
        id,
        field,
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };

    return (
      <STDMultiFormikOptimizedAutocomplete
        name="StandardName"
        // label="Slot Name"
        id="StandardName"
        value={value || []}
        onChange={handleChange}
        url={`${lookuplistViewurl}?data={"Query":{"AccessID":"2157","ScreenName":"Standard","Filter":"parentID='${recID}'","Any":""}}`}
      />
    );
  }
  //SLOT LOOKUP
  function SLOTEditAutocompleteCell(props) {
    console.log(props, "");
    const { id, value, field, api, row } = props;

    const handleChange = async (event, newValue) => {
      if (!newValue) return;

      await api.setEditCellValue({
        id,
        field,
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };

    return (
      <STDMultiFormikOptimizedAutocomplete
        name="SlotName"
        // label="Slot Name"
        id="SlotName"
        value={value || []}
        onChange={handleChange}
        url={`${lookuplistViewurl}?data={"Query":{"AccessID":"2148","ScreenName":"Slot Name","Filter":"CompanyID='${recID}'","Any":""}}`}
      />
    );
  }

  //BREAK_SLOT
  function BREAKSLOTEditAutocompleteCell(props) {
    const { id, value, field, api, row } = props;

    const handleChange = async (event, newValue) => {
      if (!newValue) return;

      await api.setEditCellValue({
        id,
        field,
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };

    return (
      <STDMultiFormikOptimizedAutocomplete
        name="SlotBreak"
        // label="Slot Break"
        id="SlotBreak"
        value={value || []}
        onChange={handleChange}
        url={`${lookuplistViewurl}?data={"Query":{"AccessID":"2156","ScreenName":"Slot Break","Filter":"CompanyID='${recID}'","Any":""}}`}
      />
    );
  }

  //TERMS COLUMNS
  const Termscolumns = [
    {
      field: "SLNO",
      headerName: "SL#",
      width: 50,
      align: "right",
      headerAlign: "center",
      hide: false,
      sortable: false,

    },
    {
      headerName: "RecordID",
      field: "RecordID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
    },
    {
      headerName: "Code",
      field: "Code",
      width: 150,
      hide: false,
      editable: true,
      headerAlign: "center",
      renderCell: (params) => {
        // show "Auto Code" only for new rows OR empty code
        if (!params.value || params.row.isNew) {
          return "Auto Code";
        }

        return params.value;
      }
    },
    // {
    //   field: "Code",
    //   headerName: "Code",
    //   width: 150,
    //   align: "left",
    //   headerAlign: "center",
    //   editable: false,
    //   // sortable: false,
    // },
    {
      field: "TermsName",
      headerName: (
        <span>
          Terms Name <span style={{ color: "red" }}>*</span>
        </span>
      ),

      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
    },
    {

      headerName: (
        <span>
          From Date <span style={{ color: "red" }}>*</span>
        </span>
      ),
      field: "FromDate", // ✅ match exact API field
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
      renderCell: (params) => params.value || "",
      renderEditCell: (params) => {
        return <EditfromDateCell {...params} />;
      },
    },
    {

      headerName: (
        <span>
          To Date <span style={{ color: "red" }}>*</span>
        </span>
      ),
      field: "ToDate", // ✅ match exact API field
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
      renderCell: (params) => params.value || "",
      renderEditCell: (params) => {
        return <EditfromDateCell {...params} />;
      },
    },
    // STD Lookup
    {
      field: "StandardID",
      headerName: "StandardID",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: false,
      hide: true,

    },
    {
      field: "StandardCode",
      headerName: "StandardCode",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: false,
      hide: true,
    },
    {
      field: "StandardName",
      headerName: (
        <span>
          Standard Name <span style={{ color: "red" }}>*</span>
        </span>
      ),

      width: 250,
      align: "left",
      headerAlign: "center",
      editable: true,

      sortable: false,   // ✅ add this
      renderCell: (params) => {
        console.log("StandardName params:", params);
        console.log("StandardName params value:", params.value);
        if (Array.isArray(params.value)) {
          return params.value.map((v) => v.Name).join(", ");
        }
        return params.value?.Name || "";
      },
      renderEditCell: (params) => {
        return <STDEditAutocompleteCell {...params} />;
      },
    },
    {
      field: "SlotID",
      headerName: "SlotID",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: false,
      hide: true,
    },
    {
      field: "SlotCode",
      headerName: "SlotCode",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: false,
      hide: true,
    },
    {
      field: "SlotName",
      // headerName: "Slot Name",
      headerName: (
        <span>
          Slot Name <span style={{ color: "red" }}>*</span>
        </span>
      ),
      width: 350,
      hide: false,
      editable: true,
      headerAlign: "center",
      sortable: false,
      //    renderCell: (params) => {
      //   return params.value?.Name || ""; // show only the name
      // },
      renderCell: (params) => {
        console.log("SlotName params:", params);
        console.log("SlotName params value:", params.value);
        if (Array.isArray(params.value)) {
          return params.value.map((v) => v.Name).join(", ");
        }
        return params.value?.Name || "";
      },
      renderEditCell: (params) => {
        return <SLOTEditAutocompleteCell {...params} />;
      },

    },
    {
      field: "BreakSlotID",
      headerName: "BreakSlotID",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: false,
      hide: true,
    },
    {
      field: "BreakSlotCode",
      headerName: "BreakSlotCode",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: false,
      hide: true,
    },
    {
      field: "BreakSlotName",
      headerName: "Break Slots",
      width: 350,
      align: "left",
      headerAlign: "center",
      editable: true,
      renderCell: (params) => {
        console.log("BreakSlotName params:", params);
        if (Array.isArray(params.value)) {
          return params.value.map((v) => v.Name).join(", ");
        }
        return params.value?.Name || "";
      },
      renderEditCell: (params) => {
        return <BREAKSLOTEditAutocompleteCell {...params} />;
      },
    },

    {
      field: "Comments",
      headerName: "Comments",
      width: 150,
      align: "left",
      headerAlign: "center",
      editable: true,
      type: "text",
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = termsRowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{ color: "primary.main" }}
              onClick={handleSaveTermsClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              onClick={handleCancelTermsClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={handleEditTermsClick(id)}   // ✅ FIX
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteTermsClick(id)} // also add this
            color="inherit"
          />,
        ];
      }
    },
  ];
  const handleRowEditTermsStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditTermsClick = (RecordID) => () => {
    setTermsRowModesModel({
      ...termsRowModesModel,
      [RecordID]: { mode: GridRowModes.Edit },
    });
  };

  const handleSaveTermsClick = (RecordID) => () => {
    setTermsRowModesModel({
      ...termsRowModesModel,
      [RecordID]: { mode: GridRowModes.View },
    });
  };


  const handleDeleteTermsClick = (RecordID) => async () => {
    // setTermsRows(rows.filter((row) => row.RecordID !== RecordID));

    setTermsRows((prev) =>
      prev.filter((row) => row.RecordID !== RecordID)
    );

    // cleanup edit mode
    setTermsRowModesModel((prev) => {
      const updated = { ...prev };
      delete updated[RecordID];
      return updated;
    });
    if (!isNaN(RecordID)) {
      const idata = {
        //RecordID: recID,
        RecordID: RecordID,
      };

      const response = await dispatch(
        postData({
          accessID: "TR355",
          action: "harddelete",
          idata: idata,
        }),
      );

      if (response.payload?.Status === "Y") {
        toast.success(response.payload.Msg);
        const data = await dispatch(companyTermsGet({ recID }));
        console.log("🚀 ~ screenChangeTerms ~ data:", data);

        if (data.payload.Status === "Y") {
          console.log(data.payload.Data, "--data.payload.Data");

          const resData = data.payload.Data.map((value) => ({
            ...value,
            // Break: value.Break === "Y", // ✅ Convert Y/N → boolean
          }));

          setTermsRows(resData);
        } else {
          setTermsRows([]);
        }


      } else {
        toast.error(response.payload?.Msg || "Operation failed");
      }
    }
  };

  const handleCancelTermsClick = (RecordID) => () => {
    setTermsRowModesModel({
      ...termsRowModesModel,
      [RecordID]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRowTerms = rows.find((row) => row.RecordID === RecordID);
    if (editedRowTerms.isNew) {
      setTermsRows(rows.filter((row) => row.RecordID !== RecordID));
    }
  };

  const validateRowTerms = (row) => {
    if (!row.TermsName) {
      return "Terms Name is required";
    }

    if (!row.FromDate) {
      return "From Date is required";
    }

    if (!row.ToDate) {
      return "To Date is required";
    }

    const isEmptyArrayOrValue = (val) => {
      if (!val) return true;
      if (Array.isArray(val)) return val.length === 0;
      if (typeof val === "object") return !val.RecordID;
      return false;
    };

    if (isEmptyArrayOrValue(row.StandardName)) {
      return "Standard Name is required";
    }

    if (isEmptyArrayOrValue(row.SlotName)) {
      return "Slot Name is required";
    }

    return null;
  };
  const processRowUpdateTerms = (newRow, oldRow) => {
    console.log(newRow, "--procesrowupdateterms newrow");

    //validation
    const error = validateRowTerms(newRow);
    if (error) {
      throw new Error(error);
    }
    //  setIsRowEditedTerms(true); // ✅ mark that editing happened



    const updatedRow = { ...newRow, isNew: false };
    console.log(newRow, "newRow");
    console.log(oldRow, "--oldRow");

    setTermsRows((prevRows) =>
      prevRows.map((row) =>
        row.RecordID === newRow.RecordID ? updatedRow : row,
      ),
    );

    console.log(updatedRow, "--updatedRow");

    return updatedRow;
  };



  const handleRowModesModelChangeTerms = (newRowModesModel) => {
    setTermsRowModesModel(newRowModesModel);
  };


  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    if (isNaN(d.getTime())) {
      // Handle DD-MM-YYYY manually
      const parts = date.split("-");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return "";
    }

    return d.toISOString().split("T")[0]; // YYYY-MM-DD
  };

  //   const handleSaveButtonClickTerms = async (action) => {
  //   console.log(termsrows, "--termsrows");

  //    if (!row.TermsName) {
  //     return "Terms Name is required";
  //   }

  //   if (!row.FromDate) {
  //     return "From Date is required";
  //   }

  //   if (!row.ToDate) {
  //     return "To Date is required";
  //   }

  //   const isEmptyArrayOrValue = (val) => {
  //     if (!val) return true;
  //     if (Array.isArray(val)) return val.length === 0;
  //     if (typeof val === "object") return !val.RecordID;
  //     return false;
  //   };

  //   if (isEmptyArrayOrValue(row.StandardName)) {
  //     return "Standard Name is required";
  //   }

  //   if (isEmptyArrayOrValue(row.SlotName)) {
  //     return "Slot Name is required";
  //   }
  // //  for (let i = 0; i < termsrows.length; i++) {
  // //     const row = termsrows[i];

  // //     if (!row.TermsName) {
  // //       toast.error(`Terms Name is required`);
  // //       return;
  // //     }

  // //     if (!row.FromDate) {
  // //       toast.error(`From Date is required`);
  // //       return;
  // //     }

  // //     if (!row.ToDate) {
  // //       toast.error(`To Date is required`);
  // //       return;
  // //     }

  // //     if (!row.StandardName || row.StandardName.length === 0) {
  // //       toast.error(`Standard Name is required`);
  // //       return;
  // //     }

  // //     if (!row.SlotName || row.SlotName.length === 0) {
  // //       toast.error(`Slot Name is required`);
  // //       return;
  // //     }
  // //   }

  //   const idata = termsrows.map((row, index) => {
  //     const slotIDs =
  //       Array.isArray(row.SlotName)
  //         ? row.SlotName.map((v) => v.RecordID).join(",")
  //         : row.SlotID || "";

  //     const breakSlotIDs =
  //       Array.isArray(row.BreakSlotName)
  //         ? row.BreakSlotName.map((v) => v.RecordID).join(",")
  //         : row.BreakSlotID || "";

  //     // const standardID =
  //     //   row.StandardName?.RecordID || row.StandardID || "";
  //    const standardID =
  //       Array.isArray(row.StandardName)
  //         ? row.StandardName.map((v) => v.RecordID).join(",")
  //         : row.StandardID || "";

  //     return {
  //       RecordID: row.isNew ? 0 : row.RecordID,
  //       CompanyID: recID,
  //       Code: row.Code,
  //       TermsName: row.TermsName,
  //       Comments: row.Comments,
  //       FromDate: formatDate(row.FromDate),   // ✅ fixed
  //       ToDate: formatDate(row.ToDate),       // ✅ fixed
  //       SlotID: slotIDs,
  //       BreakSlotID: breakSlotIDs,
  //       StandardID: standardID,
  //       IsEditable: !isNaN(parseInt(row.RecordID, 10)) ? "Y" : "N"

  //     };
  //   });

  //   console.log(idata, "--print the idata");

  //   try {
  //     const response = await dispatch(
  //       postData({
  //         accessID: "TR355",
  //         action: "insert",
  //         idata: idata,
  //       })
  //     );

  //     if (response?.payload?.Status === "Y") {
  //       toast.success(response.payload.Msg);

  //       const data = await dispatch(companyTermsGet({ recID }));

  //       if (data?.payload?.Status === "Y") {
  //         // const resData = data.payload.Data.rows.map((value) => ({
  //         //   ...value,
  //         // }));

  //         // setTermsRows(resData);
  //       } else {
  //         setTermsRows([]);
  //       }

  //     } else {
  //       toast.error(response?.payload?.Msg || "Save failed");
  //     }

  //   } catch (error) {
  //     console.error("Save error:", error);
  //     toast.error("Error occurred during save.");
  //   }
  // };

  //  function EditToolbarTerms(props) {
  //   const { setTermsRows, setRowModesModel } = props;

  //   const handleClick = () => {
  //     const id = nanoid();

  //     const nextSLNO =
  //       termsrows.length > 0
  //         ? Math.max(...termsrows.map((row) => Number(row.SLNO) || 0)) + 1
  //         : 1;

  //     setTermsRows((oldRows) => [
  //       ...oldRows,
  //       {
  //         RecordID: id,
  //         SLNO: nextSLNO,
  //         Code: "",
  //         TermsName: "",
  //         FromDate: "",
  //         ToDate: "",
  //         SlotID: "",
  //         SlotName: [],
  //         BreakSlotID: "",
  //         BreakSlotName: [],
  //         Comments: "",
  //         isNew: true,
  //       },
  //     ]);

  //     setRowModesModel((oldModel) => ({
  //       ...oldModel,
  //       [id]: { mode: GridRowModes.Edit, fieldToFocus: "Code" },
  //     }));
  //   };

  //   return (
  //     <GridToolbarContainer sx={{ marginBottom: "10px" }}>
  //       <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
  //         Add Record
  //       </Button>
  //     </GridToolbarContainer>
  //   );
  // }


  const handleSaveButtonClickTerms = async (action) => {
    console.log(termsrows, "--termsrows");
    for (let index = 0; index < termsrows.length; index++) {
      const row = termsrows[index];
      const error = validateRowTerms(row);

      if (error) {
        toast.error(`${error}`);
        return; // ✅ stops entire save function
      }
    }

    const idata = termsrows.map((row) => {
      const slotIDs = Array.isArray(row.SlotName)
        ? row.SlotName.map((v) => v.RecordID).join(",")
        : row.SlotID || "";

      const breakSlotIDs = Array.isArray(row.BreakSlotName)
        ? row.BreakSlotName.map((v) => v.RecordID).join(",")
        : row.BreakSlotID || "";

      const standardID = Array.isArray(row.StandardName)
        ? row.StandardName.map((v) => v.RecordID).join(",")
        : row.StandardID || "";

      const isNewRow = isNaN(Number(row.RecordID));
      return {

        // RecordID: row.isNew ? 0 : row.RecordID,
        // RecordID: !isNaN(parseInt(row.RecordID, 10)) ? row.RecordID : 0,
        RecordID: isNewRow ? 0 : row.RecordID,
        CompanyID: recID,
        Code: row.Code,
        TermsName: row.TermsName,
        Comments: row.Comments,
        FromDate: formatDate(row.FromDate),
        ToDate: formatDate(row.ToDate),
        SlotID: slotIDs,
        BreakSlotID: breakSlotIDs,
        StandardID: standardID,
        // IsEditable: !isNaN(parseInt(row.RecordID, 10)) ? "Y" : "N",
        IsEditable: isNewRow ? "N" : "Y",
      };
    });

    console.log(idata, "--print the idata");

    try {
      const response = await dispatch(
        postData({
          accessID: "TR355",
          action: "insert",
          idata,
        })
      );

      if (response?.payload?.Status === "Y") {
        toast.success(response.payload.Msg);

        const data = await dispatch(companyTermsGet({ recID }));

        if (data?.payload?.Status === "Y") {
          // setTermsRows(data.payload.Data.rows);
        } else {
          setTermsRows([]);
        }
      } else {
        toast.error(response?.payload?.Msg || "Save failed");
      }
    } catch (error) {
      console.error("Save error:", error);
      toast.error("Error occurred during save.");
    }
  };

  function EditToolbarTerms(props) {
    const { setTermsRows, setTermsRowModesModel } = props;

    const handleClickTerms = () => {
      const id = nanoid();

      const nextSLNO =
        termsrows.length > 0
          ? Math.max(...termsrows.map((row) => Number(row.SLNO) || 0)) + 1
          : 1;

      const newRow = {
        RecordID: id,
        SLNO: nextSLNO,
        Code: "",
        TermsName: "",
        FromDate: "",
        ToDate: "",

        StandardID: "",
        StandardCode: "",
        StandardName: [],

        SlotID: "",
        SlotCode: "",
        SlotName: [],

        BreakSlotID: "",
        BreakSlotCode: "",
        BreakSlotName: [],

        Comments: "",
        isNew: true,
      };

      setTermsRows((oldRows) => [...oldRows, newRow]);

      setTermsRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "Code" },
      }));
    };

    return (
      <GridToolbarContainer sx={{ marginBottom: "10px" }}>
        <Button color="primary" startIcon={<AddIcon />} onClick={handleClickTerms}>
          Add Record
        </Button>
      </GridToolbarContainer>
    );
  }

  return (
    <Box>
      {getLoading ? <LinearProgress /> : false}
      {BankgetLoading ? <LinearProgress /> : false}
      {BankisLoading ? <LinearProgress /> : false}
      {CompReportgetLoading ? <LinearProgress /> : false}
      {CompReportpostDataLoading ? <LinearProgress /> : false}
      {isLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Box
            display="flex"
            borderRadius="3px"
            alignItems={"center"}
            justifyContent="space-between"
          >
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Breadcrumbs
              maxItems={3}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography variant="h5" color="#0000D1"
                onClick={() => navigate("/Apps/TR014/Company")}
              >
                {mode === "E"
                  ? `Company(${rowData.CompanyName})`
                  : "Company(New)"}
              </Typography>
              {mode === "E" && show == "0" ? (
                <Typography variant="h5" color="#0000D1">Company Details</Typography>
              ) : null}
              {mode === "E" && show == "1" ? (
                <Typography variant="h5" color="#0000D1">Bank Details</Typography>
              ) : null}
              {mode === "E" && show == "2" ? (
                <Typography variant="h5" color="#0000D1">Report Settings</Typography>
              ) : null}
              {mode === "E" && show == "3" ? (
                <Typography variant="h5" color="#0000D1">Policy</Typography>
              ) : null}
              {mode === "E" && show == "4" ? (
                <Typography variant="h5" color="#0000D1">Biometric</Typography>
              ) : null}
              {/* {mode === "E" && show == "4" ? (
                <Typography variant="h5" color="#0000D1">Slots</Typography>
              ) : null}
              {mode === "E" && show == "5" ? (
                <Typography variant="h5" color="#0000D1">Terms</Typography>
              ) : null} */}

            </Breadcrumbs>
          </Box>

          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Company</MenuItem>
                  <MenuItem value={1}>Bank Details</MenuItem>
                  <MenuItem value={2}>Report Settings</MenuItem>
                  <MenuItem value={3}>Policy</MenuItem>
                  <MenuItem value={4}>Biometric</MenuItem>
                  {/* <MenuItem value={4}>Slot</MenuItem>
                  <MenuItem value={5}>Terms</MenuItem> */}
                </Select>
              </FormControl>
            ) : (
              false
            )}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton onClick={() => fnLogOut("Logout")} color="error">
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {/* {!getLoading ? ( */}
      {show == "0" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={initialValues}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                fnSave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", gap: formGap }}
                  >
                    {/* {JSON.stringify(errors)} */}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label="Code"
                      placeholder="Auto"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.code}
                      focused
                      inputProps={{ maxLength: 5 }}
                      InputProps={{ readOnly: true }}
                      name="code"
                      autoFocus
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label={
                        <>
                          Name{" "}
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      // onInvalid={(e) => {
                      //   e.target.setCustomValidity("Please fill the Name");
                      // }}
                      // onInput={(e) => {
                      //   e.target.setCustomValidity("");
                      // }}
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="name"
                      error={!!touched.name && !!errors.name}
                      helperText={touched.name && errors.name}
                      sx={{ gridColumn: "span 2" }}
                      focused
                      // required
                      inputProps={{ maxLength: 50 }}
                      autoFocus
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label={
                        <>
                          Address{" "}
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      value={values.address}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="address"
                      error={!!touched.address && !!errors.address}
                      helperText={touched.address && errors.address}
                      sx={{ gridColumn: "span 2" }}
                      focused
                      // required
                      // onInvalid={(e) => {
                      //   e.target.setCustomValidity("Please fill the Address");
                      // }}
                      // onInput={(e) => {
                      //   e.target.setCustomValidity("");
                      // }}
                      inputProps={{ maxLength: 500 }}
                      multiline
                    />
                    {/* <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                      }}
                    >
                      <FormControl
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      > */}
                    <CheckinAutocomplete
                      label={
                        <>
                          Country
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      id="country"
                      name="country"
                      value={values.country}
                      error={!!touched.country && !!errors.country}
                      helperText={touched.country && errors.country}
                      onChange={(e, newValue) => {
                        setFieldValue("country", newValue);
                      }}
                      // log
                      url={`${store.getState().globalurl.listViewurl
                        }?data={"Query":{"AccessID":"2003","ScreenName":"Country","Filter":"","Any":"","CompId":"4"}}`}
                    />

                    {/* {touched.country && errors.country && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "2px" }}>
                            {errors.country}
                          </div>
                        )} */}
                    {/* </FormControl> */}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label="RBI Code"
                      value={values.rbiCode}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="rbiCode"
                      error={!!touched.rbiCode && !!errors.rbiCode}
                      helperText={touched.rbiCode && errors.rbiCode}
                      focused
                    // sx={{
                    //   mt: 1
                    // }}
                    // inputProps={{ maxLength: 5 }}
                    />
                    {/* </FormControl> */}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      label={
                        <>
                          Pincode
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      // required
                      // onInvalid={(e) => {
                      //   e.target.setCustomValidity("Please fill the Pincode");
                      // }}
                      value={values.pincode}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="pincode"
                      error={!!touched.pincode && !!errors.pincode}
                      helperText={touched.pincode && errors.pincode}
                      sx={{ gridColumn: "span 2" }}
                      focused
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 6);

                        e.target.setCustomValidity("");
                      }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      label={
                        <>
                          Phone
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      // required
                      // onInvalid={(e) => {
                      //   e.target.setCustomValidity("Please fill the Phone");
                      // }}
                      value={values.phone}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="phone"
                      sx={{ gridColumn: "span 2" }}
                      focused
                      error={!!touched.phone && !!errors.phone}
                      helperText={touched.phone && errors.phone}
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10);

                        e.target.setCustomValidity("");
                      }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      label="No Of Users"
                      value={values.noofusers}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="noofusers"
                      sx={{
                        gridColumn: "span 2",
                        input: { textAlign: "right" },
                      }}
                      focused
                      onWheel={(e) => e.target.blur()}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label="LUT"
                      value={values.Lut}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="Lut"
                      inputProps={{ readOnly: true }}
                      focused
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      label="Sort Order"
                      value={values.sortOrder}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="sortOrder"
                      error={!!touched.sortOrder && !!errors.sortOrder}
                      helperText={touched.sortOrder && errors.sortOrder}
                      sx={{
                        gridColumn: "span 2",
                        background: "",
                        input: { textAlign: "right" },
                      }}
                      focused
                      onWheel={(e) => e.target.blur()}
                    />
                  </FormControl>
                  <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label="Web URL"
                      value={values.web}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="web"
                      sx={{ gridColumn: "span 2" }}
                      focused
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="email"
                      label={
                        <>
                          Email ID
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      // required
                      // onInvalid={(e) => {
                      //   e.target.setCustomValidity("Please fill the Email Id");
                      // }}
                      // onInput={(e) => {
                      //   e.target.setCustomValidity("");
                      // }}
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.email && !!errors.email}
                      helperText={touched.email && errors.email}
                      name="email"
                      sx={{ gridColumn: "span 2" }}
                      focused
                      inputProps={{ maxLength: 45 }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="iECode"
                      name="iECode"
                      value={values.iECode}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="I.E.Code"
                      focused
                      onWheel={(e) => e.target.blur()}
                      error={!!touched.iECode && !!errors.iECode}
                      helperText={touched.iECode && errors.iECode}
                    />


                    <FormControl
                      disabled={mode === "E"}
                      variant="standard"
                      fullWidth
                      focused
                      error={mode !== "E" && !!touched.Type && !!errors.Type}>
                      <InputLabel id="Type-label">
                        Type
                        <span style={{ color: "red", fontSize: "20px" }}>*</span>
                      </InputLabel>

                      <Select
                        labelId="Type-label"
                        id="Type"
                        name="Type"
                        value={values.Type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="S">Startup</MenuItem>
                        <MenuItem value="I">Institute</MenuItem>
                        <MenuItem value="C">Construction</MenuItem>
                      </Select>

                      {mode !== "E" && touched.Type && errors.Type && (
                        <FormHelperText>{errors.Type}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl variant="standard" fullWidth focused>
                      <InputLabel id="module-label">Module</InputLabel>

                      <Select
                        labelId="module-label"
                        id="Module"
                        name="Module"
                        multiple
                        // Convert comma-separated string to array for MUI Select
                        value={values.Module ? values.Module.split(",") : []}
                        onChange={(e) => {
                          // Convert array back to comma-separated string
                          handleChange({
                            target: {
                              name: "Module",
                              value: e.target.value.join(","),
                            },
                          });
                        }}
                        onBlur={handleBlur}
                        renderValue={(selected) => selected.join(", ")}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Task">Task</MenuItem>
                        <MenuItem value="Project">Project</MenuItem>
                        <MenuItem value="Attendance">Attendance</MenuItem>
                        <MenuItem value="Request">Request</MenuItem>
                        <MenuItem value="Assessment">Assessment</MenuItem>
                        <MenuItem value="Myprofile">Myprofile</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl variant="standard" fullWidth focused>
                      <InputLabel id="start5s-label">Stock 5S Data Source</InputLabel>

                      <Select
                        labelId="start5s-label"
                        id="Stock5sDataSource"
                        name="Stock5sDataSource"
                        value={values.Stock5sDataSource || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="M">Module</MenuItem>
                        <MenuItem value="E">Excel</MenuItem>
                        <MenuItem value="A">API</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label="GST"
                      // label={
                      //   <>
                      //     GST
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       {" "}
                      //       *{" "}
                      //     </span>
                      //   </>
                      // }
                      // required
                      // onInvalid={(e) => {
                      //   e.target.setCustomValidity("Please fill the GST");
                      // }}
                      // onInput={(e) => {
                      //   e.target.setCustomValidity("");
                      // }}
                      value={values.gst}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="gst"
                      error={!!touched.gst && !!errors.gst}
                      helperText={touched.gst && errors.gst}
                      focused
                      inputProps={{ maxLength: 15 }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label={
                        <>
                          Subscription Code
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      // required
                      // onInvalid={(e) => {
                      //   e.target.setCustomValidity(
                      //     "Please fill the Subscription Code"
                      //   );
                      // }}
                      // onInput={(e) => {
                      //   e.target.setCustomValidity("");
                      // }}
                      value={values.license}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="license"
                      error={!!touched.license && !!errors.license}
                      helperText={touched.license && errors.license}
                      focused
                      onInput={(e) => {
                        e.target.setCustomValidity(""); // Clear the custom error
                      }}
                      inputProps={{ maxLength: 4 }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      label="Notice Period"
                      // label={
                      //   <>
                      //     Notice Period
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       {" "}
                      //       *{" "}
                      //     </span>
                      //   </>
                      // }
                      value={values.noticeperiod}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="noticeperiod"
                      error={!!touched.noticeperiod && !!errors.noticeperiod}
                      helperText={touched.noticeperiod && errors.noticeperiod}
                      focused
                      // inputProps={{ maxLength: 15 }}
                      InputProps={{

                        inputProps: {
                          maxLength: 15,
                          style: { textAlign: "right" }
                        }
                      }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      label="No Of Employees"
                      value={values.noOfEmployees}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="noOfEmployees"
                      sx={{
                        gridColumn: "span 2",
                        input: { textAlign: "right" },
                      }}
                      focused
                      onWheel={(e) => e.target.blur()}
                    />

                    <Box>
                      <Field
                        //  size="small"
                        type="checkbox"
                        name="disable"
                        id="disable"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        as={Checkbox}
                        label="Disable"
                      />

                      <FormLabel focused={false}>Disable</FormLabel>
                      <Field
                        //  size="small"
                        type="checkbox"
                        name="subattapplicable"
                        id="subattapplicable"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        as={Checkbox}
                        label="subattapplicable"
                      />

                      <FormLabel focused={false}>Subject Attendance applicable</FormLabel>
                    </Box>
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                >
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate("/Apps/TR014/Company");
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
          {/* </Box> */}
        </Paper>
      ) : (
        false
      )}

      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={BankInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Banksave(values);
              }, 100);
            }}
            validationSchema={BankValidationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {/* {CompanyAutoCode == "Y" ? (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label="Code"
                      variant="standard"
                      placeholder="Auto"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      InputProps={{ readOnly: true }}
                      // autoFocus
                    />
                  ) : ( */}
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label={
                      <>
                        Code
                        {/* <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span> */}
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    autoFocus
                  />
                  {/* )} */}
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={
                      <>
                        Name
                        {/* <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span> */}
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                  // required
                  //autoFocus={CompanyAutoCode == "Y"}
                  />
                  <TextField
                    name="bankname"
                    type="text"
                    id="bankname"
                    label={
                      <>
                        Bank Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.bankname}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.bankname && !!errors.bankname}
                    helperText={touched.bankname && errors.bankname}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />
                  {/* <TextField
                    name="Accounttype"
                    type="text"
                    id="Accounttype"
                    label={
                      <>
                        Account Type
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.Accounttype}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.Accounttype && !!errors.Accounttype}
                    helperText={touched.Accounttype && errors.Accounttype}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />  */}

                  <TextField
                    select   // ✅ makes it dropdown
                    name="Accounttype"
                    type="text"
                    id="Accounttype"
                    label={
                      <>
                        Account Type
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.Accounttype}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.Accounttype && !!errors.Accounttype}
                    helperText={touched.Accounttype && errors.Accounttype}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    fullWidth
                  >
                    <MenuItem value="">Select Account Type</MenuItem>
                    <MenuItem value="Savings">Savings</MenuItem>
                    <MenuItem value="Current">Current</MenuItem>
                  </TextField>

                  <TextField
                    name="branchname"
                    label={
                      <>
                        Branch Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.branchname}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // onChange={(e) => {
                    //   const input = e.target.value.toUpperCase();
                    //   if (/^[A-Z0-9]*$/.test(input) || input === "") {
                    //     handleChange({
                    //       target: {
                    //         name: "branchname",
                    //         value: input,
                    //       },
                    //     });
                    //   }
                    // }}
                    error={!!touched.branchname && !!errors.branchname}
                    helperText={touched.branchname && errors.branchname}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="ifsc"
                    label={
                      <>
                        IFSC Code
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.ifsc}
                    onBlur={handleBlur}
                    //  onChange={handleChange}
                    onChange={(e) => {
                      const input = e.target.value.toUpperCase();
                      if (/^[0-9A-Z]*$/.test(input) || input === "") {
                        // This updates Formik value correctly
                        handleChange({
                          target: {
                            name: "ifsc",
                            value: input,
                          },
                        });
                      }
                    }}
                    error={!!touched.ifsc && !!errors.ifsc}
                    helperText={touched.ifsc && errors.ifsc}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="accountholdname"
                    type="text"
                    id="accountholdname"
                    label={
                      <>
                        Account Holder Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.accountholdname}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={
                      !!touched.accountholdname && !!errors.accountholdname
                    }
                    helperText={
                      touched.accountholdname && errors.accountholdname
                    }
                    // inputProps={{ maxLength: 10 }}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />

                  <TextField
                    name="bankloc"
                    type="text"
                    id="bankloc"
                    label={
                      <>
                        Bank Location
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.bankloc}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                    error={!!touched.bankloc && !!errors.bankloc}
                    helperText={touched.bankloc && errors.bankloc}
                  />
                  {/* <TextField
                    name="accountnumber"
                    type="number"
                    id="accountnumber"
                    label="Account Number"
                    variant="standard"
                    focused
                     required
                    value={values.accountnumber}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  /> */}
                  <TextField
                    name="accountnumber"
                    type="text" // use "text" instead of "number" to preserve leading 0s and better control
                    id="accountnumber"
                    label={
                      <>
                        Account Number
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.accountnumber}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Allow only digits
                      if (/^\d*$/.test(input)) {
                        handleChange({
                          target: {
                            name: "accountnumber",
                            value: input,
                          },
                        });
                      }
                    }}
                    error={!!touched.accountnumber && !!errors.accountnumber}
                    helperText={touched.accountnumber && errors.accountnumber}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="bankaddress"
                    type="text"
                    id="bankaddress"
                    label={
                      <>
                        Bank Address
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.bankaddress}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    error={!!touched.bankaddress && !!errors.bankaddress}
                    helperText={touched.bankaddress && errors.bankaddress}
                    autoFocus
                  />
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  {/* {YearFlag == "true" ? ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>
                  {/* ) : (
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                  )}{" "} */}

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}

      {show == "2" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={CompReportInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                CompReportsave(values);
              }, 100);
            }}
            //validationSchema={BankValidationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {/* {CompanyAutoCode == "Y" ? (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label="Code"
                      variant="standard"
                      placeholder="Auto"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      InputProps={{ readOnly: true }}
                      // autoFocus
                    />
                  ) : ( */}
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label={
                      <>
                        Code
                        {/* <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span> */}
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    autoFocus
                  />
                  {/* )} */}
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={
                      <>
                        Name
                        {/* <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span> */}
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                  // required
                  //autoFocus={CompanyAutoCode == "Y"}
                  />
                </Box>
                <Box
                  // display="flex"
                  // justifyContent="space-between"
                  // padding={1}
                  // gap="20px",
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <Box>
                      {/* HEADER IMAGE */}
                      <Tooltip title="Header Image Upload">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            // accept="all/*"
                            accept="image/png, image/jpeg, image/jpg"
                            type="file"
                            onChange={getFileHeaderChange1}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Button
                        size="small"
                        variant="contained"
                        component={"a"}
                        onClick={() => {
                          CompReportgetdata.CmHeader || headerImage
                            ? window.open(
                              headerImage
                                ? store.getState().globalurl.imageUrl +
                                headerImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.CmHeader,
                              "_blank",
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        Header Image View
                      </Button>
                    </Box>
                    <Box>
                      {headerPreview ||
                        headerImage ||
                        CompReportgetdata.CmHeader ? (
                        <img
                          src={
                            headerPreview
                              ? headerPreview
                              : headerImage
                                ? store.getState().globalurl.imageUrl +
                                headerImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.CmHeader
                          }
                          width={175}
                          height={175}
                          style={{
                            objectFit: "contain",
                            border: "1px solid #ccc",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            color: "red",
                            marginTop: 10,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 175,
                            height: 175,
                            border: "1px solid #ccc",
                          }}
                        >
                          Please upload image
                        </div>
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {/* FOOTER IMAGE */}
                    <Box>
                      <Tooltip title="Footer Upload">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            // accept="all/*"
                            accept="image/png, image/jpeg, image/jpg"
                            type="file"
                            onChange={getFileFooterChange}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Button
                        size="small"
                        variant="contained"
                        component={"a"}
                        onClick={() => {
                          CompReportgetdata.CmFooter || footerImage
                            ? window.open(
                              footerImage
                                ? store.getState().globalurl.imageUrl +
                                footerImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.CmFooter,
                              "_blank",
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        Footer Image View
                      </Button>
                    </Box>
                    <Box>
                      {footerPreview ||
                        footerImage ||
                        CompReportgetdata.CmFooter ? (
                        <img
                          src={
                            footerPreview
                              ? footerPreview
                              : footerImage
                                ? store.getState().globalurl.imageUrl +
                                footerImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.CmFooter
                          }
                          width={175}
                          height={175}
                          style={{
                            objectFit: "contain",
                            border: "1px solid #ccc",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            color: "red",
                            marginTop: 10,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 175,
                            height: 175,
                            border: "1px solid #ccc",
                          }}
                        >
                          Please upload image
                        </div>
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {/* E-SIGN IMAGE */}
                    <Box>
                      <Tooltip title="E-Sign Upload">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            // accept="all/*"
                            accept="image/png, image/jpeg, image/jpg"
                            type="file"
                            onChange={getFileESignChange}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Button
                        size="small"
                        variant="contained"
                        component={"a"}
                        onClick={() => {
                          CompReportgetdata.Signature || esignImage
                            ? window.open(
                              esignImage
                                ? store.getState().globalurl.imageUrl +
                                esignImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.Signature,
                              "_blank",
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        E-Sign Image View
                      </Button>
                    </Box>
                    <Box>
                      {eSignPreview ||
                        esignImage ||
                        CompReportgetdata.Signature ? (
                        <img
                          src={
                            eSignPreview
                              ? eSignPreview
                              : esignImage
                                ? store.getState().globalurl.imageUrl +
                                esignImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.Signature
                          }
                          width={175}
                          height={175}
                          style={{
                            objectFit: "contain",
                            border: "1px solid #ccc",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            color: "red",
                            marginTop: 10,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 175,
                            height: 175,
                            border: "1px solid #ccc",
                          }}
                        >
                          Please upload image
                        </div>
                      )}
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <Box>
                      {/* QR CODE IMAGE */}
                      <Tooltip title="QR Code Upload">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            // accept="all/*"
                            accept="image/png, image/jpeg, image/jpg"
                            type="file"
                            onChange={getFileQRCodeChange}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Button
                        size="small"
                        variant="contained"
                        component={"a"}
                        onClick={() => {
                          CompReportgetdata.QrCode || qrCodeImage
                            ? window.open(
                              qrCodeImage
                                ? store.getState().globalurl.imageUrl +
                                qrCodeImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.QrCode,
                              "_blank",
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        QR Code View
                      </Button>
                    </Box>
                    <Box>
                      {qrCodePreview ||
                        qrCodeImage ||
                        CompReportgetdata.QrCode ? (
                        <img
                          src={
                            qrCodePreview
                              ? qrCodePreview
                              : qrCodeImage
                                ? store.getState().globalurl.imageUrl +
                                qrCodeImage
                                : store.getState().globalurl.imageUrl +
                                CompReportgetdata.QrCode
                          }
                          width={175}
                          height={175}
                          style={{
                            objectFit: "contain",
                            border: "1px solid #ccc",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            color: "red",
                            marginTop: 10,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 175,
                            height: 175,
                            border: "1px solid #ccc",
                          }}
                        >
                          Please upload image
                        </div>
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  {/* {YearFlag == "true" ? ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>
                  {/* ) : (
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                  )}{" "} */}

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {/* Policy */}

      {/* {show == "3" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={BankInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Banksave(values);
              }, 100);
            }}
            validationSchema={BankValidationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                            <Typography variant="h5" padding={1}>Permission:</Typography>

           
           <Box
                                display="grid"
                                gridTemplateColumns="repeat(4, minMax(0, 1fr))"
                                gap={formGap}
                                padding={1}
                                sx={{
                                    "& > div": {
                                        gridColumn: isNonMobile ? undefined : "span 4", // Adjust for mobile view
                                    },
                                }}
                            >
                                <FormControl
                                    fullWidth
                                    sx={{ gridColumn: "span 2", gap: formGap }}
                                >
             
                  <TextField
                    name="noofpermhrs"
                    type="number"
                    id="noofpermhrs"
                    label={
                      <>
                        No Of Hours / Permission
                        
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.noofpermhrs}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.noofpermhrs && !!errors.noofpermhrs}
                    helperText={touched.noofpermhrs && errors.noofpermhrs}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
    style: { textAlign: "right" }
  }}
                   
                  />
                  <TextField
                    name="noofpermpermonth"
                    type="number"
                    id="noofpermpermonth"
                    label={
                      <>
                       No Of Permission / Month
                     
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.noofpermpermonth}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.noofpermpermonth && !!errors.noofpermpermonth}
                    helperText={touched.noofpermpermonth && errors.noofpermpermonth}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                  inputProps={{
                    style: { textAlign: "right" }
                  }}
                    autoFocus
                  />
                  <TextField
                    name="lossofpayrate"
                    type="number"
                    id="lossofpayrate"
                    label={
                      <>
                        Loss of pay rate   
                      
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.lossofpayrate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.lossofpayrate && !!errors.lossofpayrate}
                    helperText={touched.lossofpayrate && errors.lossofpayrate}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                    style: { textAlign: "right" }
                  }}
                    autoFocus
                  />
                  </FormControl>
                       </Box>
                    <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                            <Typography variant="h5" padding={1}>Irregular:</Typography>

                            <Box
                                display="grid"
                                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                gap={formGap}
                                padding={1}
                                sx={{
                                    "& > div": {
                                        gridColumn: isNonMobile ? undefined : "span 4",
                                    },
                                }}
                            >
                                <FormControl fullWidth sx={{ gridColumn: "span 2", gap: formGap }}>
  <TextField
                    name="freeormonth"
                    type="number"
                    id="freeormonth"
                    label={
                      <>
                        Free / Month   
                      
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.freeormonth}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.freeormonth && !!errors.freeormonth}
                    helperText={touched.freeormonth && errors.freeormonth}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                    style: { textAlign: "right" }
                  }}
                    autoFocus
                  />
                    <TextField
                    name="lossofpayrate2"
                    type="number"
                    id="lossofpayrate2"
                    label={
                      <>
                        Loss of pay / Rate  
                      
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.lossofpayrate2}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.lossofpayrate2 && !!errors.lossofpayrate2}
                    helperText={touched.lossofpayrate2 && errors.lossofpayrate2}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                    style: { textAlign: "right" }
                  }}
                    autoFocus
                  />


 </FormControl>
                       </Box>
                          <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                            <Typography variant="h5" padding={1}>Overtime:</Typography>

                            <Box
                                display="grid"
                                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                gap={formGap}
                                padding={1}
                                sx={{
                                    "& > div": {
                                        gridColumn: isNonMobile ? undefined : "span 4",
                                    },
                                }}
                            >
                                <FormControl fullWidth sx={{ gridColumn: "span 2", gap: formGap }}>
   <TextField
                    name="salryrateorday"
                    type="number"
                    id="salryrateorday"
                    label={
                      <>
                    Salry rate / Day  
                      
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.salryrateorday}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.salryrateorday && !!errors.salryrateorday}
                    helperText={touched.salryrateorday && errors.salryrateorday}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                    style: { textAlign: "right" }
                  }}
                    autoFocus
                  />

             

 </FormControl>
                       </Box>
           
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                 
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>
               

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )} */}

      {show == "3" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={PolicyInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Policysave(values);
              }, 100);
            }}
            // validationSchema={PolicyValidationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label={<>Code</>}
                    variant="standard"
                    focused
                    // required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    autoFocus
                  />
                  {/* )} */}
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={<>Name</>}
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                  />
                </Box>
                <Typography variant="h5" padding={1}>
                  Leave:
                </Typography>

                <Box
                  display="grid"
                  gridTemplateColumns="repeat(2, 1fr)"
                  // gridTemplateColumns="repeat(4, minMax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2", // Adjust for mobile view
                    },
                  }}
                >

                  <TextField
                    name="noofpaidleave"
                    type="number"
                    id="noofpaidleave"
                    label={<>No Of Paid Leave / Year</>}
                    variant="standard"
                    focused
                    value={values.noofpaidleave}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.noofpaidleave && !!errors.noofpaidleave}
                    helperText={touched.noofpaidleave && errors.noofpaidleave}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                  />
                </Box>
                <Typography variant="h5" padding={1}>
                  Permission:
                </Typography>

                <Box
                  display="grid"
                  gridTemplateColumns="repeat(2, 1fr)"
                  // gridTemplateColumns="repeat(4, minMax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2", // Adjust for mobile view
                    },
                  }}
                >
                  {/* <FormControl
                                    fullWidth
                                    sx={{ gridColumn: "span 2", gap: formGap }}
                                > */}

                  <TextField
                    name="noofpermhrs"
                    type="number"
                    id="noofpermhrs"
                    label={<>No Of Hours / Permission</>}
                    variant="standard"
                    focused
                    value={values.noofpermhrs}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.noofpermhrs && !!errors.noofpermhrs}
                    helperText={touched.noofpermhrs && errors.noofpermhrs}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                  />
                  <TextField
                    name="noofpermpermonth"
                    type="number"
                    id="noofpermpermonth"
                    label={<>No Of Permission / Month</>}
                    variant="standard"
                    focused
                    value={values.noofpermpermonth}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={
                      !!touched.noofpermpermonth && !!errors.noofpermpermonth
                    }
                    helperText={
                      touched.noofpermpermonth && errors.noofpermpermonth
                    }
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                    autoFocus
                  />
                  <TextField
                    name="lossofpayrate"
                    type="number"
                    id="lossofpayrate"
                    label={<>Loss Of Pay Rate</>}
                    variant="standard"
                    focused
                    value={values.lossofpayrate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.lossofpayrate && !!errors.lossofpayrate}
                    helperText={touched.lossofpayrate && errors.lossofpayrate}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                    autoFocus
                  />
                  {/* </FormControl> */}
                </Box>
                <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                <Typography variant="h5" padding={1}>
                  Irregular:
                </Typography>

                <Box
                  display="grid"
                  gridTemplateColumns="repeat(2, 1fr)"
                  // gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  {/* <FormControl fullWidth sx={{ gridColumn: "span 2", gap: formGap }}> */}
                  <TextField
                    name="freeormonth"
                    type="number"
                    id="freeormonth"
                    label={<>Free / Month</>}
                    variant="standard"
                    focused
                    value={values.freeormonth}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.freeormonth && !!errors.freeormonth}
                    helperText={touched.freeormonth && errors.freeormonth}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                    autoFocus
                  />
                  <TextField
                    name="lossofpayrate2"
                    type="number"
                    id="lossofpayrate2"
                    label={<>Loss Of Pay Rate</>}
                    variant="standard"
                    focused
                    value={values.lossofpayrate2}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.lossofpayrate2 && !!errors.lossofpayrate2}
                    helperText={touched.lossofpayrate2 && errors.lossofpayrate2}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                    autoFocus
                  />

                  {/* </FormControl> */}
                </Box>
                <Divider variant="fullWidth" sx={{ mt: "20px" }} />
                <Typography variant="h5" padding={1}>
                  Overtime:
                </Typography>

                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", gap: formGap }}
                  >
                    <TextField
                      name="salryrateorday"
                      type="number"
                      id="salryrateorday"
                      label={<>Salary Rate / Day</>}
                      variant="standard"
                      focused
                      value={values.salryrateorday}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={
                        !!touched.salryrateorday && !!errors.salryrateorday
                      }
                      helperText={
                        touched.salryrateorday && errors.salryrateorday
                      }
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                      autoFocus
                    />
                  </FormControl>
                </Box>

                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "4" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={BiometricInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Biometricsave(values);
              }, 100);
            }}
            // validationSchema={PolicyValidationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? "span 2" : "span 4",
                    },
                  }}
                >
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label="Code"
                    variant="standard"
                    focused
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    autoFocus
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />

                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label="Name"
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />

                  <TextField
                    name="appname"
                    type="text"
                    id="appname"
                    label="Application Name"
                    variant="standard"
                    size="small"
                    focused
                    value={values.appname}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />

                  <TextField
                    name="deviceid"
                    type="number"
                    id="deviceid"
                    label="Device ID"
                    variant="standard"
                    size="small"
                    focused
                    value={values.deviceid}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />

                  <TextField
                    name="authorization"
                    type="text"
                    id="authorization"
                    label="Authorization"
                    variant="standard"
                    size="small"
                    focused
                    value={values.authorization}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.authorization && !!errors.authorization}
                    helperText={touched.authorization && errors.authorization}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />

                  <TextField
                    name="apikey"
                    type="text"
                    id="apikey"
                    label="API Key"
                    variant="standard"
                    size="small"
                    focused
                    value={values.apikey}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.apikey && !!errors.apikey}
                    helperText={touched.apikey && errors.apikey}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />

                  <TextField
                    name="url"
                    type="text"
                    id="url"
                    label="URL"
                    variant="standard"
                    size="small"
                    focused
                    value={values.url}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.url && !!errors.url}
                    helperText={touched.url && errors.url}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />

                  {/* Pulling Cycle + Time */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        values.pulling === "D" ? "1fr 1fr" : "1fr",
                      gap: formGap,
                      gridColumn: "span 2",
                    }}
                  >
                    <TextField
                      fullWidth
                      select
                      name="pulling"
                      id="pulling"
                      label="Pulling Cycle"
                      variant="standard"
                      size="small"
                      focused
                      value={values.pulling}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    >
                      <MenuItem value="D">Daily</MenuItem>
                      <MenuItem value="H">Hourly</MenuItem>
                    </TextField>

                    {values.pulling === "D" && (
                      <TextField
                        fullWidth
                        name="time"
                        type="time"
                        id="time"
                        label="Time"
                        variant="standard"
                        size="small"
                        focused
                        value={values.time}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        sx={{
                          backgroundColor: "#ffffff",
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#f5f5f5",
                          },
                        }}
                      />
                    )}
                  </Box>

                  <TextField
                    name="input"
                    type="text"
                    id="input"
                    label="Input"
                    variant="standard"
                    size="small"
                    focused
                    rows={3}
                    multiline
                    value={values.input}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                </Box>


                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {/* {show == "4" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={PolicyInitialValue}
            onSubmit={(values, setSubmitting) => {
              // setTimeout(() => {
              //   Policysave(values);
              // }, 100);
            }}
            // validationSchema={PolicyValidationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label={<>Code</>}
                    variant="standard"
                    focused
                    // required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    autoFocus
                  />
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={<>Name</>}
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                  />
                </Box>

                <Box
                  m="5px 0 0 0"
                  height={dataGridHeight}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#D3D3D3",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={rows}
                    columns={columns}
                    loading={exploreLoading}
                    editMode="row"
                    disableSelectionOnClick
                    rowModesModel={rowModesModel}
                    onRowModesModelChange={handleRowModesModelChange}
                    onRowEditStop={handleRowEditStop}
                    processRowUpdate={processRowUpdate}
                    getRowId={(row) => row.RecordID}
                    isCellEditable={(params) => {
                      if (params.field === "SlotCode") return false;
                      return true;
                    }}
                    disableRowSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    onProcessRowUpdateError={(error) => {
                      console.error(
                        "Row update validation failed:",
                        error.message,
                      );
                      toast.error(error.message);
                    }}
                    components={{
                      Toolbar: EditToolbar,
                    }}
                    componentsProps={{
                      toolbar: { setRows, setRowModesModel },
                    }}
                    rowsPerPageOptions={[5, 10, 20]}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                    pagination
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                  />
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleSaveButtonClick}
                  >
                    Save
                  </Button>

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )} */}

      {show == "5" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={PolicyInitialValue}
            onSubmit={(values, setSubmitting) => {
              // setTimeout(() => {
              //   Policysave(values);
              // }, 100);
            }}
            // validationSchema={PolicyValidationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label={<>Code</>}
                    variant="standard"
                    focused
                    // required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    autoFocus
                  />
                  {/* )} */}
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={<>Name</>}
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                  />
                </Box>

                <Box
                  m="5px 0 0 0"
                  height={dataGridHeight}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#D3D3D3",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={termsrows}
                    columns={Termscolumns}
                    loading={exploreLoading}
                    editMode="row"
                    disableSelectionOnClick
                    rowModesModel={termsRowModesModel}
                    onRowModesModelChange={handleRowModesModelChangeTerms}
                    onRowEditStop={handleRowEditTermsStop}
                    processRowUpdate={processRowUpdateTerms}
                    getRowId={(row) => row.RecordID || row.id}
                    isCellEditable={(params) => {
                      if (params.field === "Code") return false;
                      return true;
                    }}
                    disableRowSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    onProcessRowUpdateError={(error) => {
                      console.error("Row update validation failed:", error.message,);
                      toast.error(error.message);
                    }}
                    components={{
                      Toolbar: EditToolbarTerms,
                    }}
                    componentsProps={{
                      toolbar: { setTermsRows, setTermsRowModesModel },
                    }}
                    rowsPerPageOptions={[5, 10, 20]}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                    pagination
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                  />
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleSaveButtonClickTerms}
                  >
                    Save
                  </Button>

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
    </Box>
  );
};

export default Editcompany;
